import api from "@/services/api";
import {clearRequestIndicators, prepareRequestIndicators, successRequestIndicators} from "@/services/helper";

export default {
    /**
     * GET ALL TABLES
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    GET_TABLES: async ({ commit }) => {
        prepareRequestIndicators(commit, true)
        commit('setTables', [])
        
        try {
            const axios = api('node-api')
            const response = await axios.get('/tables')
            
            if (response.data.tables) {
                commit('setTables', response.data.tables || [])
                successRequestIndicators(commit, response.data.message)
            }
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
    /**
     * GET A TABLE
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    GET_TABLE: async ({ commit }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            const response = await axios.get(`/tables/${payload.id}`)
            
            if (response.data.table) {
                commit('setTable', response.data.table)
                successRequestIndicators(commit, response.data.message)
                return response.data.table
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
    /**
     * NEW TABLE
     * @param commit
     * @param getters
     * @param payload
     * @returns {Promise<void>}
     * @constructor
     */
    NEW_TABLE: async ({ commit, getters }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            const response = await axios.post(`/tables`, payload)
            
            if (response.data.table) {
                const tables = (getters.tables || [])
                tables.push(response.data.table)
                
                commit('setTables', tables)
                successRequestIndicators(commit, response.data.message)
                return response.data.table
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
    /**
     * EDIT TABLE
     * @param commit
     * @param getters
     * @param payload
     * @returns {Promise<T>}
     * @constructor
     */
    EDIT_TABLE: async ({ commit, getters }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            const response = await axios.put(`/tables/${payload._id}`, payload)
            
            if (response.data.table) {
                const tables = (getters.tables || [])
                tables.find((table) => {
                    if (table._id === payload._id) {
                        return response.data.table
                    }
                })
                
                commit('setTables', tables)
                successRequestIndicators(commit, response.data.message)
                return tables
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
    /**
     * DELETE TABLE
     * @param commit
     * @param getters
     * @param payload
     * @returns {Promise<T>}
     * @constructor
     */
    DELETE_TABLE: async ({ commit, getters }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            const response = await axios.delete(`/tables/${payload._id}`)
            
            if (response.data.table) {
                const tables = (getters.tables || []).filter((table) => {
                    if (table._id !== payload._id) {
                        return table
                    }
                })
                
                commit('setTables', tables)
                successRequestIndicators(commit, response.data.message)
                return tables
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
    /**
     * ADD PLAYERS TO TABLE
     * @param commit
     * @param getters
     * @param payload
     * @returns {Promise<T>}
     * @constructor
     */
    TABLE_ADD_PLAYERS: async ({ commit, getters }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            const response = await axios.post(`/tables/${payload._id}/players`, payload)
            
            if (response.data.table) {
                const tables = (getters.tables || [])
                tables.find((table) => {
                    if (table._id === payload._id) {
                        return response.data.table
                    }
                })
                
                commit('setTables', tables)
                commit('setTable', response.data.table)
                successRequestIndicators(commit, response.data.message)
                return tables
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
    /**
     * DELETE PLAYER FROM A TABLE
     * @param commit
     * @param getters
     * @param payload
     * @returns {Promise<T>}
     * @constructor
     */
    TABLE_REMOVE_PLAYERS: async ({ commit, getters }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            const response = await axios.delete(`/tables/${payload._id}/players/${payload.player_id}`, payload)
            
            if (response.data.table) {
                const tables = (getters.tables || [])
                tables.find((table) => {
                    if (table._id === payload._id) {
                        return response.data.table
                    }
                })
                
                commit('setTables', tables)
                commit('setTable', response.data.table)
                successRequestIndicators(commit, response.data.message)
                return tables
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
    /**
     * DELETE PLAYER FROM A WAIT LIST
     * @param commit
     * @param getters
     * @param payload
     * @returns {Promise<T>}
     * @constructor
     */
    TABLE_REMOVE_FROM_WAIT_LIST: async ({ commit, getters }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            const response = await axios.delete(`/tables/${payload._id}/waiting_list/${payload.player_id}`, payload)

            if (response.data.table) {
                const tables = (getters.tables || [])
                tables.find((table) => {
                    if (table._id === payload._id) {
                        return response.data.table
                    }
                })

                commit('setTables', tables)
                commit('setTable', response.data.table)
                successRequestIndicators(commit, response.data.message)
                return tables
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
    /**
     * END PLAYERS TO TABLE
     * @param commit
     * @param getters
     * @param payload
     * @returns {Promise<T>}
     * @constructor
     */
    END_TABLE: async ({ commit, getters }, payload) => {
        prepareRequestIndicators(commit, true)
        try {
            const axios = api('node-api')
            const response = await axios.post(`/tables/${payload._id}/end/event`, payload)
            
            if (response.data.table) {
                const tables = (getters.tables || [])
                tables.find((table) => {
                    if (table._id === payload._id) {
                        return response.data.table
                    }
                })
                
                commit('setTables', tables)
                commit('setTable', response.data.table)
                successRequestIndicators(commit, response.data.message)
                return tables
            }
            return null
        } catch (e) {
            clearRequestIndicators(commit, true)
        }
    },
}


